import { render, staticRenderFns } from "./ClassicMatterDimensionsTab.vue?vue&type=template&id=8d0f5b8a&scoped=true&"
import script from "./ClassicMatterDimensionsTab.vue?vue&type=script&lang=js&"
export * from "./ClassicMatterDimensionsTab.vue?vue&type=script&lang=js&"
import style0 from "./ClassicMatterDimensionsTab.vue?vue&type=style&index=0&id=8d0f5b8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0f5b8a",
  null
  
)

export default component.exports